<template>
  <div>
    <!-- Fondo oscuro -->
    <div v-show="isVisible" class="overlay" @click.stop></div>

    <!-- Modal -->
    <v-card v-show="isVisible" class="payment-modal" @click.stop>
      <div class="modal-header">
        <button
          class="close-btn"
          @click="close"
          aria-label="Cerrar"
        >
          &times;
        </button>
      </div>

      <div class="modal-content">
        <div id="toku-container" class="toku-container">
          <iframe
            id="terminos"
            src="/terminos_pago_en_linea/TerminosDomiciliacion.pdf"
            class="pdf-frame"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "ModalTyC",
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    close() {
      this.isVisible = false;
      document.body.style.overflow = "";
    },
  },
};
</script>

<style scoped>
/* fondo overlay */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
}

/* modal principal (v-card) */
.payment-modal {
  display: flex;
  flex-direction: column;

  width: 90vw;
  max-width: 900px;   /* lo ajustas */
  min-width: 320px;

  height: 85vh;       /* ocupa buena parte vertical */
  max-height: 90vh;
  min-height: 360px;

  margin: auto;
  border-radius: 12px;
  background-color: white;

  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1010;

  overflow: hidden;

  /* IMPORTANT: quitar padding interno que reduce área del iframe */
  padding: 0;
}

/* Si Vuetify añade .v-card__text u otras clases internas con padding, forzamos reset */
::v-deep .payment-modal .v-card__text,
::v-deep .payment-modal .v-card__title,
::v-deep .payment-modal .v-card__content {
  padding: 0 !important;
  margin: 0 !important;
}

/* header (botón cerrar) */
.modal-header {
  flex: 0 0 44px;        /* ocupa espacio fijo en la parte superior */
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 8px 12px;
  box-sizing: border-box;
  background: transparent;
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 1.6rem;
  line-height: 1;
  cursor: pointer;
}

/* contenido que debe crecer */
.modal-content {
  flex: 1 1 auto;        /* ocupa el resto del modal */
  display: flex;
  /* clave para permitir que el hijo flex con overflow funcione: */
  min-height: 0;
  overflow: hidden;
  padding: 0;
  box-sizing: border-box;
}

/* wrapper del iframe */
.toku-container {
  flex: 1 1 auto;
  min-height: 0;       /* CRUCIAL para que el iframe pueda encogerse dentro del flex container */
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
}

/* iframe que ocupa todo */
.pdf-frame {
  display: block;      /* evita espacios blancos debajo (inline-block) */
  width: 100%;
  height: 100%;
  border: none;
}

/* estilo extra para apariencia */
.payment-modal {
  box-shadow: 0 8px 30px rgba(0,0,0,0.45);
  border-radius: 10px;
}
</style>
